function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/no-unused-state */
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
/**
 * The Cron component provides time based renders of components useful for implementing
 * countdown timers and the like!
 *
 * ## Usage
 *
 * ```
 * const count = 0;
 *
 * // simple stop watch
 * <Cron interval={1000}>
 *   {({ start, stop }) => {
 *      {count += 1}
 *      <Button onClick={start}>Start</Button>
 *      <Button onClick={stop}>Stop</Button>
 *   }}
 * </Cron>
 * ```
 *
 * ## Props
 */

var Cron = /*#__PURE__*/function (_PureComponent) {
  _inherits(Cron, _PureComponent);

  var _super = _createSuper(Cron);

  function Cron() {
    var _this;

    _classCallCheck(this, Cron);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      lastTimeoutId: null,
      elapsedTime: 0
    });

    _defineProperty(_assertThisInitialized(_this), "start", function () {
      if (_this.timeoutId) return;

      _this._tick();
    });

    _defineProperty(_assertThisInitialized(_this), "_tick", function () {
      var interval = _this.props.interval;

      if (interval < 700) {
        throw new Error("Cron interval ".concat(interval, "ms is too short"));
      }

      _this.timeoutId = setTimeout(function () {
        _this.setState(function (_ref) {
          var elapsedTime = _ref.elapsedTime;
          return {
            lastTimeoutId: _this.timeoutId,
            elapsedTime: elapsedTime + interval
          };
        });

        _this._tick();
      }, interval);
    });

    _defineProperty(_assertThisInitialized(_this), "stop", function () {
      clearTimeout(_this.timeoutId);
      _this.timeoutId = null;
      _this.elapsedTime = 0;
    });

    return _this;
  }

  _createClass(Cron, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.start();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var elapsedTime = this.state.elapsedTime;
      if (typeof children !== 'function') return null;
      return children({
        start: this.start,
        stop: this.stop,
        elapsedTime: elapsedTime
      }) || null;
    }
  }]);

  return Cron;
}(PureComponent);

Cron.defaultProps = {
  children: function children() {
    return null;
  },
  interval: 1000
};
Cron.propTypes = {
  /**
   * UI to render at a regular interval as renderProp
   */
  children: PropTypes.func,

  /**
   * The interval at which to trigger a re-render
   */
  interval: PropTypes.number
};
export default Cron;